var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useState } from 'react';
export var usePaginationState = function (initialState) {
    var _a = useState({
        pageIndex: (initialState === null || initialState === void 0 ? void 0 : initialState.pageIndex) || 0,
        pageSize: (initialState === null || initialState === void 0 ? void 0 : initialState.pageSize) || 25,
    }), pagination = _a[0], setPagination = _a[1];
    var setPageSize = function (pageSize) {
        setPagination(function (prev) { return (__assign(__assign({}, prev), { pageSize: pageSize })); });
    };
    var setPageIndex = function (pageIndex) {
        setPagination(function (prev) { return (__assign(__assign({}, prev), { pageIndex: pageIndex })); });
    };
    return {
        pagination: pagination,
        setPagination: setPagination,
        setPageSize: setPageSize,
        setPageIndex: setPageIndex,
    };
};
